import { AfterViewInit, Component, OnChanges, OnDestroy, OnInit, Renderer2 } from '@angular/core'

@Component({
	selector: 'app-generate-course-form',
	templateUrl: './generate-course-form.component.html',
	styleUrls: ['./generate-course-form.component.scss']
})

export class GenerateCourseFormComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
	
	constructor(private renderer: Renderer2) { }

	ngOnInit(): void {
		// console.log('form init')
	}

	ngAfterViewInit(): void {
		// console.log('form after view init')
	}

	ngOnChanges(): void {
		// console.log('form changes')
	}

	ngOnDestroy(): void {
		// console.log('form destroy')
	}

	move(event: Event) {
		let button = event.currentTarget as HTMLButtonElement
		
		let forward = button.dataset.direction === 'forward'
		let back = button.dataset.direction === 'back'
		
		let parent = button.dataset.parent
		let prev = button.dataset.prev
		let next = button.dataset.next

		let parentElement = document.getElementById(`generate-course-form-${parent}`)
		let prevElement = document.getElementById(`generate-course-form-${prev}`)
		let nextElement = document.getElementById(`generate-course-form-${next}`)
		// console.log(parentElement)
		// console.log(prevElement)
		// console.log(nextElement)

		if (forward) {
			this.animateCSS(this.renderer, parentElement, 'fadeOutLeft').then(() => {
				this.renderer.addClass(parentElement, 'd-none')
				this.renderer.removeClass(nextElement, 'd-none')
				this.animateCSS(this.renderer, nextElement, 'fadeInRight')
			})
		} else if (back) {
			this.animateCSS(this.renderer, parentElement, 'fadeOutRight').then(() => {
				this.renderer.addClass(parentElement, 'd-none')
				this.renderer.removeClass(prevElement, 'd-none')
				this.animateCSS(this.renderer, prevElement, 'fadeInLeft')
			})
		}
	}

	animateCSS = (renderer: Renderer2, element: any, animation: string, prefix = 'animate__') =>
		// We create a Promise and return it
		new Promise((resolve, reject) => {
			// console.log(element)
			const animationName = `${prefix}${animation}`
			
			renderer.addClass(element, `${prefix}animated`)
			renderer.addClass(element, animationName)
			renderer.addClass(element, `${prefix}fast`)

			// When the animation ends, we clean the classes and resolve the Promise
			function handleAnimationEnd(event: Event) {
				event.stopPropagation()
				renderer.removeClass(element, `${prefix}animated`)
				renderer.removeClass(element, animationName)
				renderer.removeClass(element, `${prefix}fast`)
				resolve('Animation ended')
			}

			// node.addEventListener('animationend', handleAnimationEnd, { once: true })
			renderer.listen(element, 'animationend', handleAnimationEnd)
		})
}